import styled from "styled-components";

export const QueryExplanation = styled.p`
  font-size: 1.5rem;
  font-weight: semibold;
  margin: 2rem 0;

  @media (max-width: 548px) {
    font-size: 1rem;
    margin: 1rem 0;
  }
`;

export const SubTitle = styled.h3`
  font-size: 1.7rem;
  margin-bottom: 2rem;
  
  @media (max-width: 548px) {
    font-size: 1.2rem;
    margin: 3rem 0 1rem 0;
  }
`;

export const Title = styled.h2`
  font-size: 2.3rem;
  margin-bottom: 2rem;
  
  @media (max-width: 548px) {
    font-size: 1.5rem;
    margin: 3rem 0 1rem 0;
  }
`;